import { useState } from "react";
import { useDataProvider, useNotify, useRefresh } from "react-admin";
import { useRichApiErrorNotify } from "@/hooks/useRichApiErrorNotify";

/**
 * Upserts the policy-period summary Note (US 5370 / ADR-052 §10) via
 * POST /policies/{policyId}/note. On success it refreshes so the Claims Summary
 * re-reads the policy (the note is overlaid onto the policy read path). The note
 * lives in the dedicated policy_notes table — never a synced store — so it
 * survives document reloads. Sibling to useUpsertClaimantPolicyNote.
 */
export const useUpsertPolicyNote = () => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const notifyError = useRichApiErrorNotify();
  const refresh = useRefresh();
  const [saving, setSaving] = useState(false);

  const saveNote = async (policyId: string, note: string): Promise<boolean> => {
    setSaving(true);
    try {
      await dataProvider.invoke(`policies/${policyId}/note`, { data: { note } });
      notify("Note saved", { type: "success" });
      refresh();
      return true;
    } catch (error) {
      notifyError(error);
      return false;
    } finally {
      setSaving(false);
    }
  };

  return { saveNote, saving };
};
